// extracted by mini-css-extract-plugin
export default {"certificationsContainer":"Certifications_certificationsContainer__s1coM","codecademyCerts":"Certifications_codecademyCerts__hipX2","msCert":"Certifications_msCert__Jh807"};